<template>
  <v-card v-if="items && items.length > 0" class="mt-4 mx-auto pt-2">
    <v-card-title class="pt-2">
      <div>User Registrations</div>
      <v-spacer></v-spacer>
      {{ items.length }}
    </v-card-title>
    <v-divider class=""></v-divider>
    <v-sheet
      elevation="0"
      class="v-sheet--offset mx-auto"
      max-width="calc(100% - 20px)"
    >
      <StatsSpark
        v-if="items && items.length > 0"
        :items="items"
        :limit="limit ? limit : 7"
        :format="format ? format : 'DD MMM YYYY'"
        :label_format="label_format ? label_format : 'DMMM'"
        :field="field ? field : 'created_at'"
        :sort_callback="sort_callback ? sort_callback : handleSort"
      />
    </v-sheet>

    <v-card-text class="pt-2" v-if="lastRecord">
      <v-divider class="my-2"></v-divider>
      <v-icon class="mr-2" small> mdi-clock </v-icon>
      <span class="text-caption grey--text font-weight-light"
        >last registration
        <u
          @click.stop="
            $router.push({
              name: 'dashboard-auth-user',
              params: { id: lastRecord.id },
            })
          "
          >{{ lastRecord.display_name }}</u
        >
        {{ lastRecord.ago }}
      </span>
    </v-card-text>
  </v-card>
</template>

<script>
import { axios } from "@/plugins/axios";
import { mapGetters } from "vuex";
import StatsSpark from "./StatsSpark";
import moment from "@/plugins/moment";

export default {
  name: "home",
  props: ["format", "field", "title", "limit", "label_format", "sort_callback"],
  components: {
    StatsSpark,
  },
  data() {
    return {
      items: [],
      lastRecord: null,
    };
  },
  computed: {
    ...mapGetters({
      authUser: "auth/user",
    }),
  },
  watch: {},
  methods: {
    handleSort(grouped) {
      return grouped.reverse();
    },
    fetchAllitems() {
      return axios.get("auth/users/?orderby=id|desc").then((res) => {
        this.items = res.data;
        let last = res.data[0];
        last.ago = moment(
          last[this.field ? this.field : "created_at"]
        ).fromNow();
        this.lastRecord = last;
      });
    },
  },
  created() {
    this.fetchAllitems();
  },
};
</script>

<style>
</style>